import React from 'react'
import { graphql } from 'gatsby'
import parse from 'html-react-parser'

import Layout from '../components/layout'
import Seo from '../components/seo'

const PrivacyPage = ({ data, location }) => (
  <Layout location={location}>
    <Seo title="Datenschutzerklärung" />
    <div className="px-4 py-16 mx-auto prose md:py-24">
      {data.wpPartnerSeite.partnerseite.legal.customImprintAndPrivacy &&
      data.wpPartnerSeite.partnerseite.legal.datenschutz
        ? parse(data.wpPartnerSeite.partnerseite.legal.datenschutz)
        : parse(data.wpPage.content)}
    </div>
  </Layout>
)

export default PrivacyPage

export const pageQuery = graphql`
  query Datenschutz {
    wpPage(databaseId: { eq: 22 }) {
      title
      content
    }
    wpPartnerSeite {
      title
      partnerseite {
        legal {
          datenschutz
          customImprintAndPrivacy
        }
      }
    }
  }
`
